module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ((_vm.inline ? 'width:auto; display:inline-block;' : ''))
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      round: true
    },
    attrs: {
      "disabled": _vm.count <= _vm.min
    },
    on: {
      "click": _vm.subtract
    }
  }, [_c('icon', {
    attrs: {
      "name": "Minus",
      "scale": 1.5
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "counter"
  }, [_c('strong', [_vm._v(_vm._s(_vm.count))]), _vm._v(_vm._s(_vm.suffix))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      round: true
    },
    attrs: {
      "disabled": _vm.count >= _vm.max
    },
    on: {
      "click": _vm.add
    }
  }, [_c('icon', {
    attrs: {
      "name": "Plus",
      "scale": 1.5
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d448b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/CounterButton.vue
// module id = 918
// module chunks = 0